import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 16,
    height: 16,
  },
});

export const CustomRiskLibraryIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M7.4999 8L7.3999 4H8.6L8.4999 8H7.4999Z" fill="currentColor" />
      <path d="M7.4999 9H8.4999V10H7.4999V9Z" fill="currentColor" />
      <path
        d="M2 10C2 11.1046 2.89543 12 4 12V13.9129C4 14.3401 4.50106 14.5705 4.8254 14.2925L7.5 12H12C13.1046 12 14 11.1046 14 10V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V10ZM5 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4V10C13 10.5523 12.5523 11 12 11H7.13008L5 12.8258V11Z"
        fill="currentColor"
      />
    </svg>
  );
};
